import type { RequestInterceptor } from '../../types';

export const internalNetworkInterceptor: RequestInterceptor = (ctx, next) => {
    if (typeof window !== 'undefined' || !ctx.options?.networkConfig) {
        return next(ctx);
    } // Skip if on client side or if no networkConfig provided

    const { networkConfig, ...restOptions } = ctx.options;
    const { internalNamespace, internalPort, internalService, internalHeaders } = networkConfig;

    if (!internalNamespace || !internalPort || !internalService) {
        return next(ctx);
    } // Skip if internal network params are incomplete

    const url = new URL(ctx.input.toString());

    url.protocol = 'http';
    url.port = internalPort.toString();
    url.host = `${internalService}.${internalNamespace}.svc.cluster.local`;

    return next({
        input: url,
        init: {
            ...ctx.init,
            headers: {
                ...ctx.init?.headers,
                ...internalHeaders
            }
        },
        options: restOptions
    });
};
